import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'

export default {
  name: 'investigationDEPSTrensferDetail',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      day: '',
      gapday: '',
     gapdaypopup: 0,
      amountpopup:0,
      typepopup:0,
      showeditmodel: false,
      v1:0,
      depstransferids:'',
      amount:'',
      username:'',
      isactive:0,
      type: '',
      types: [{
        stdstatusmasterid: 12,
        label: 'Dispute'
      }, {
        stdstatusmasterid: 13,
        label: 'RTODispute'
      }, {
        stdstatusmasterid: 11,
        label: 'Shortage'
      }],
      gapday: '',
      gapdays: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      },
      {
        value: 6,
        label: '6'
      }, {
        value: 7,
        label: '7'
      }, {
        value: 8,
        label: '8'
      }, {
        value: 9,
        label: '9'
      }, {
        value: 10,
        label: '10'
      }],
    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.gapdaypopup = this.$route.query.days;
    this.amountpopup = this.$route.query.amount;
     this.v1 = this.$route.query.stdstatusmasterid;
    this.isactive=this.$route.query.isactive
     this.depstransferids = this.$route.query.depstransferid;
     this.username = window.localStorage.getItem('username');

     switch (this.v1) {
      case 12:
        this.typepopup = "Disput";
        break;
      case 13:
        this.typepopup = "RTODispute";
        break;
      case 11:
        this.typepopup = "Shortage";
        break;
      default:
        this.typepopup = " ";
        break;
}
    },

  methods: {

    updateDispute() {
      if (!this.type.stdstatusmasterid) {
        this.$alertify.error("Please Select Type.")
      } else if (!this.gapday.label) {
        this.$alertify.error("Please Select Gapdays.")
      }
else{
      this.input = ({
        DepsTransferId: this.depstransferids,
        Days:this.gapday.label,
        STDStatusMasterId: this.type.stdstatusmasterid,
        Amount: this.amountpopup,
        LastModifiedBy: this.username,
        isActive:this.isactive

      });
      axios({
        method: 'post',
        url: apiUrl.api_url + 'updateDEPSTransferDetails',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        if (result.data.code == 200) {
          this.$alertify.success(result.data.message)
          this.$router.push({ path: '/editDEPSTransferDetails' });
        }
        else {
          this.$alertify.error(result.data.message)
        }

      })
    }

    },


    Backinvestigation() {

        this.$router.push({ path: '/editDEPSTransferDetails' });

    },
     //Open edit model

  }
}



// WEBPACK FOOTER //
// ./src/views/components/EditDEPS/EditDEPS.component.js